export default __webpack_public_path__ + "static/media/sheld.1bdbf4c8.png";